import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type WorkflowIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const WorkflowIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: WorkflowIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Workflow'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 14.8333 18.1667'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.75 2.41667H12.4167C12.8587 2.41667 13.2826 2.59226 13.5952 2.90482C13.9077 3.21738 14.0833 3.64131 14.0833 4.08333V15.75C14.0833 16.192 13.9077 16.616 13.5952 16.9285C13.2826 17.2411 12.8587 17.4167 12.4167 17.4167H2.41667C1.97464 17.4167 1.55072 17.2411 1.23816 16.9285C0.925595 16.616 0.75 16.192 0.75 15.75V4.08333C0.75 3.64131 0.925595 3.21738 1.23816 2.90482C1.55072 2.59226 1.97464 2.41667 2.41667 2.41667H4.08333M3.4165 7.08325H4.4165M3.4165 10.0833H4.4165M3.4165 13.0833H4.4165M7.4165 7.08325H11.4165M7.4165 10.0833H11.4165M7.4165 13.0833H11.4165M4.91667 0.75H9.91667C10.3769 0.75 10.75 1.1231 10.75 1.58333V3.25C10.75 3.71024 10.3769 4.08333 9.91667 4.08333H7.41667H4.91667C4.45643 4.08333 4.08333 3.71024 4.08333 3.25V1.58333C4.08333 1.1231 4.45643 0.75 4.91667 0.75Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
